import login from './login'
import leadGenerator from './lead-generator'

export default {
  login,
  leadGenerator
}
